// extracted by mini-css-extract-plugin
export var blog_image = "index-module--blog_image--4a8ab";
export var blog_post = "index-module--blog_post--3a2a4";
export var blog_post_wrapper = "index-module--blog_post_wrapper--d611e";
export var category = "index-module--category--86c79";
export var date = "index-module--date--f2924";
export var date_category = "index-module--date_category--175dc";
export var prev_next = "index-module--prev_next--3c0f6";